import React, { useState, forwardRef, useImperativeHandle } from "react";
import "../ficha-master.css";
import Api from "../../../../api/global.service.js";
import BlockUi from "react-block-ui";
import Swal from "sweetalert2";

const ModalFichaCoopClonaAnterior = forwardRef((props, ref) => {
  const [show, setShow] = useState(false);
  const [blocking, setBlocking] = useState(false);
  const [fichaMaster, setFichaMaster] = useState(null);
  const [fichas, setFichas] = useState([]);
  const [fichaSeleccionadaId, setFichaSeleccionadaId] = useState(null);
  const [nombre, setNombre] = useState("");
  const [descripcion, setDescripcion] = useState("");

  useImperativeHandle(ref, () => ({
    show: showHandler,
    setData: (data) => setFichaMaster(data),
  }));

  const showHandler = () => {
    setShow(true);
    setFichaSeleccionadaId(null);
    setFichas([]);
    setNombre("");
    setDescripcion("");
  };

  const closeHandler = () => {
    setShow(false);
  };

  React.useEffect(() => {
    if (!show) {
      return;
    }

    if (!fichaMaster?.id_kobo_ficha_principal) {
      return;
    }

    setBlocking(true);
    Api.getAll(`ficha/kobo/master/${fichaMaster.id_kobo_ficha_principal}/fichas_copiables_coop`)
      .then((response) => {
        setFichas(response.data || []);
        setBlocking(false);
      })
      .catch(() => {
        setBlocking(false);
      });
  }, [show, fichaMaster?.id_kobo_ficha_principal]);

  const seleccionarFicha = (item) => {
    setFichaSeleccionadaId(item.id_kobo_ficha_principal);
    setNombre(item?.nombre || "");
    setDescripcion(item?.descripcion || "");
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!fichaSeleccionadaId) {
      await Swal.fire({
        icon: "warning",
        title: "",
        text: "Seleccione una ficha para copiar",
      });
      return;
    }

    setBlocking(true);
    Api.create(`ficha/kobo/master/${fichaMaster.id_kobo_ficha_principal}/copiar_fichas_coop`, {
      fichas: [fichaSeleccionadaId],
      nombre,
      descripcion,
    })
      .then(async () => {
        setBlocking(false);
        await Swal.fire({
          icon: "success",
          title: "Proceso finalizado",
          text: "Ficha copiada correctamente.",
        });
        closeHandler();
        if (typeof props.onFinish === "function") {
          props.onFinish();
        }
      })
      .catch(async (e) => {
        setBlocking(false);
        await Swal.fire({
          icon: "error",
          title: "Error",
          text: e?.response?.data?.message || "Ocurrió un error al copiar las fichas",
        });
      });
  };

  return (
    <div
      className="modal"
      style={{
        display: show ? "block" : "none",
        backgroundColor: "rgba(0,0,0,0.2)",
      }}
    >
      <div className="modal-dialog modal-dialog-centered modal-lg modal-ficha-master__dialog">
        <div className="modal-content" style={{ height: "100%" }}>
          <div className="modal-header" style={{ flex: "inherit" }}>
            <h4 style={{ color: "black" }}>{props.title}</h4>
            <button
              onClick={() => closeHandler()}
              type="button"
              className="btn"
              style={{ borderRadius: "20px 20px 20px 20px" }}
            >
              <i className="fa fa-times"></i>
            </button>
          </div>
          <div className="modal-body">
            <BlockUi tag="div" message="" blocking={blocking} renderChildren={true}>
              <form onSubmit={handleSubmit}>
                <div style={{ maxHeight: "55vh", overflowY: "auto" }}>
                  <table className="table table-bordered table-striped">
                    <thead>
                      <tr>
                        <th style={{ width: 60 }}>Sel</th>
                        <th>ID Ficha</th>
                        <th>Nombre</th>
                        <th>Cooperativa</th>
                      </tr>
                    </thead>
                    <tbody>
                      {fichas.map((item) => (
                        <tr key={item.id_kobo_ficha_principal}>
                          <td>
                            <input
                              type="radio"
                              name="ficha_seleccionada"
                              checked={fichaSeleccionadaId === item.id_kobo_ficha_principal}
                              onChange={() => seleccionarFicha(item)}
                            />
                          </td>
                          <td>{item?.id_kobo_ficha_principal}</td>
                          <td>{item?.nombre}</td>
                          <td>{item?.cooperativa?.nombre || "-"}</td>
                        </tr>
                      ))}
                      {fichas.length === 0 && (
                        <tr>
                          <td colSpan="4">No hay fichas disponibles para copiar</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                <div className="m-b-15">
                  <label>Nombre</label>
                  <input
                    type="text"
                    className="form-control"
                    value={nombre}
                    onChange={(e) => setNombre(e.target.value)}
                    disabled={!fichaSeleccionadaId}
                  />
                </div>

                <div className="m-b-15">
                  <label>Descripción</label>
                  <input
                    type="text"
                    className="form-control"
                    value={descripcion}
                    onChange={(e) => setDescripcion(e.target.value)}
                    disabled={!fichaSeleccionadaId}
                  />
                </div>

                {!blocking && (
                  <button type="submit" className="btn btn-sirio" style={{ borderRadius: "20px 20px 20px 20px" }}>
                    <i className="fa fa-copy"></i> Copiar ficha
                  </button>
                )}
              </form>
            </BlockUi>
          </div>
        </div>
      </div>
    </div>
  );
});

export default ModalFichaCoopClonaAnterior;
